<div class="address-details-container">
    <label class="label-text" *ngIf="useStandingAuth" data-testid="deliveryAddressLabel">Delivery address</label>
    <div *ngIf="(recipient$ | async) === 'firstParty' || useStandingAuth; else elseBlock"
        data-testid="accountHolderAddressDetails" id="first-party-details" class="big-bottom-spacer">
        <span *ngIf="!useStandingAuth" class="grey-text" id="checkInputPage_accountHolderAddressLabel"
            data-testid="accountHolderAddressLabel">Account holder address</span>
        <div class="addressLine" *ngFor="let addressLine of (defaultRecipient$ | async); let i = index">
            <span [id]="'checkInputPage_firstPartyAddressDetailsLine-' + (i + 1)"
                [attr.data-testid]="'addressLine-' + (i + 1)">{{addressLine}}</span>
        </div>
    </div>
    <ng-template #elseBlock>
        <div>
            <!-- Base third party fields (addressee name/street address) -->
            <mm-check-third-party-address-fields [parentForm]="parentForm" [recipientSelection$]="recipientSelection$"
                [firmAddress]="firmAddress" [isFromEdit$]="isFromEdit$" [isFromCreateStandingAuth]="isFromCreateStandingAuth" [shouldDisableFieldForEditQcd]="shouldDisableFieldForEditQcd" class="check-third-party-address-fields"></mm-check-third-party-address-fields>

            <!-- Domestic specific fields -->
            <mm-check-third-party-domestic-fields
                *ngIf="(recipient$ | async) === 'thirdPartyDomestic' || (recipient$ | async) === 'advisoryFirm'"
                [parentForm]="parentForm" [stateList$]="stateList$" [recipientSelection$]="recipientSelection$"
                [firmAddress]="firmAddress" [isFromEdit$]="isFromEdit$" [shouldDisableFieldForEditQcd]="shouldDisableFieldForEditQcd">
            </mm-check-third-party-domestic-fields>

            <!-- International specific fields -->
            <mm-check-third-party-international-fields *ngIf="(recipient$ | async) === 'thirdPartyInternational'" class="check-third-party-international-fields"
                [parentForm]="parentForm" [countryList$]="countryList$" [shouldDisableFieldForEditQcd]="shouldDisableFieldForEditQcd"></mm-check-third-party-international-fields>
        </div>
    </ng-template>
</div>